import React, { ReactElement } from "react";
import AuthContext from "./AuthContext";

type Props = React.PropsWithChildren & {
  setUser: (user: any) => void;
};

export default function AuthProvider({ setUser, children }: Props): ReactElement {
  return <AuthContext.Provider value={{ setUser }}>{children}</AuthContext.Provider>;
}
